import useQuote from "./useQuote";
import useUser from "./useUser";
export default function useInProgressDisable(name: string) {
  const quoteContext = useQuote();
  const { state } = quoteContext;
  const { metadata } = state;
  const { role } = useUser();

  const inProgressFields = [
    "loanProduct",
    "productType",
    "channel",
    "prepaymentPenalty",
    "referralFee",
    "submissionType",
    "borrowerIsReferral",
    "yieldSpread",
    "buyUpDownOption",
    "buyUpDownPercentage",
    "scenario1",
    "scenario2",
    "scenario3",
    "preferredScenario1",
    "preferredScenario2",
    "preferredScenario3",
    "brokerFee",
    "brokerProcessingFee",
    "isZeroOrigFee",
    "finalRateOverride",
    "finalOrigFeeOverride",
    "autoFee",
    "autoRate",
    "commissionReduction",
    "adjustedBlendedLTC",
    "adjustedPurchaseLTC",
    "adjustedARV",
    "deferredOrigPercent",
    "achExempt",
    "achRequired",
    "processingFeeOverride",
    "twoFourUnit",
    "originationFeeAdjustment",
    "buyUpPercentage"
  ];

  const exceptionFields = [
    "finalOrigFeeOverride",
    "processingFeeOverride",
    "achExempt",
    "achRequired",
    "finalRateOverride",
    "commissionReduction",
    "exceptionType",
    "blendedLTCOverride",
    "purchaseLTCOverride",
    "arvOverride",
    "achExempt",
    "achRequired",
    "rateReductionOverride",
    "finalRateOverride",
    "commissionReduction",
  ];

  if (
    (metadata?.underwriterStatus === "Final" ||
      metadata?.underwriterStatus === "Sales Finalized") &&
    name.toLowerCase().includes("scenario")
  ) {
    return true;
  }

  if (inProgressFields.includes(name)) return false;

  if (exceptionFields.includes(name) && role === "Capital Markets") {
    return false;
  }

  return metadata?.underwriterStatus === "Under Review";
}
